import React, { useState, useRef, useEffect } from "react";
import {
  Row,
  Col,
  Form,
  Input,
  Select,
  Button,
  Switch,
  DatePicker,
  Popconfirm,
  message,
  Spin,
  Badge,
  Checkbox,
} from "antd";
import Sidebar from "../../../../components/AdminComponents/SideNav";
import {
  SecondaryNavTNCommunications,
  SettingsMenu,
} from "../../../../components/AdminComponents/MenuItems";
import SecondaryNav from "../../../../components/AdminComponents/SecondaryNav2";
import MaintainenceModal from "../../../../components/legacyComp/tetsing/MaintainenceModal";
import {
  capitalizeWords,
  remainingViewportHeight,
} from "../../../../components/icons/ApplicationColor";
import {
  BackwardOutlined,
  FormOutlined,
  DeleteOutlined,
  PlusCircleOutlined,
  LinkOutlined,
  EditTwoTone,
  HistoryOutlined,
} from "@ant-design/icons";
import ThirdBar from "../../../../components/AdminComponents/ThirdBar";
import axiosInstance from "../../../../api/Axios";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import moment from "moment";
import { quillModules } from "./helper";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
const { Option } = Select;
const { RangePicker } = DatePicker;
const CustomNotificationsEdit = () => {
  const { id } = useParams();
  const history = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(true);
  const closeDowntimeModal = () => setIsModalVisible(false);
  const [links, setLinks] = useState({});
  const formRef = useRef();
  const [messageApi, contextHolder] = message.useMessage();
  const [content, setContent] = useState("");
  const [useStructuredPoints, setUseStructuredPoints] = useState(false);
  const onFinish = async (values) => {
    const updatedCustomPoints = values.customPoints?.map(
      (pointData, index) => ({
        ...pointData,
        linkName: links?.[index]?.name || "",
        linkUrl: links?.[index]?.url || "",
      })
    );
    const finalValues = {
      ...values,
      bullet_point: useStructuredPoints,
      customPoints: useStructuredPoints ? updatedCustomPoints : null,
      customHtml: !useStructuredPoints
        ? btoa(unescape(encodeURIComponent(content)))
        : null,
    };

    console.log("Final Form Values:", finalValues);
    createCustomNotification(finalValues);
  };

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const UpdateSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "Custom Notification Edit successful",
      duration: 5,
    });
  };
  // eslint-disable-next-line no-unused-vars
  const UpdateFailed = (err = "Custom Notification Edit failed") => {
    messageApi.open({
      type: "error",
      content: err,
      duration: 5,
    });
  };
  const Loadafter3sec = () => {
    setTimeout(() => {
      history("/access-manager/notifications/custom-notifications/");
    }, 2000);
  };
  const createCustomNotification = async (data) => {
    try {
      await axiosInstance.put(`/customnotification/${id}/`, data, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      Loadafter3sec();
      UpdateSuccessfull();
    } catch (err) {
      UpdateFailed();
    }
  };
  //   const [formData, setFormData] = useState({
  //     sub_category: "",
  //     priority: "",
  //     title: "",
  //     status: true,
  //     application: "",
  //     dateRange: [],
  //     customPoints: [],
  //   });
  const [formData, setFormData] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const LoadUserData = async () => {
      setLoading(true);
      try {
        const res = await axiosInstance.get(`/customnotification/${id}/`);
        setFormData(res.data);
        //console.log(res.data);
        setLoading(false);
        //console.log(data);
      } catch (err) {
        setLoading(false);
      }
    };
    LoadUserData();
  }, [id]);

  const [category, setCategory] = useState("");
  const [formDataPass, setFormDataPass] = useState({
    sub_category: "",
    priority: "",
    title: "",
    status: true,
    application: "",
    dateRange: [],
    customPoints: [],
    customHtml: null,
  });
  useEffect(() => {
    if (!loading && formRef.current) {
      console.log("Setting customPoints:", formData?.custompoints);

      const updatedData = {
        sub_category: formData?.sub_category || "",
        priority: formData?.priority || "",
        title: formData?.notification_content || "",
        status: formData?.status ?? true,
        application: formData?.application || "",
        dateRange:
          formData?.start_date && formData?.end_date
            ? [
                dayjs(formData.start_date).startOf("minute"),
                dayjs(formData.end_date).startOf("minute"),
              ]
            : [],
        customPoints:
          formData?.custompoints?.length > 0
            ? formData.custompoints.map((item) => ({ point: item.point || "" }))
            : [{ point: "" }],
      };

      formRef.current.setFieldsValue(updatedData);
      setContent(formData?.customhtml || null);
      setUseStructuredPoints(formData?.bullet_point || false);
      setFormDataPass(updatedData);
      if (formData?.custompoints?.length) {
        const formattedLinks = {};
        formData.custompoints.forEach((item, index) => {
          formattedLinks[index] = {
            name: item.linkName || "",
            url: item.linkUrl || "",
          };
        });
        setLinks(formattedLinks);
      }
      setCategory(formData?.sub_category);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, formData]);

  const [applications, setApplications] = useState([]);
  useEffect(() => {
    const LoadUser = async () => {
      try {
        const res = await axiosInstance.get("/traineryoneapplictaionlist/");
        //console.log(res.data);
        setApplications(res.data);
      } catch (err) {
        //console.log(err);
      }
    };
    LoadUser();
  }, []);
  const thirdMenuData = [
    {
      path: `/access-manager/notifications/custom-notifications/edit/${id}`,
      name: "Edit Custom Notification",
      icon: (
        <EditTwoTone
          style={{ fontSize: "15.5px", marginRight: "5px", margintop: "1px" }}
        />
      ),
    },
    {
      path: `/access-manager/notifications/custom-notifications/logs/${id}`,
      name: "Audit Logs",
      icon: (
        <HistoryOutlined
          style={{ fontSize: "15.5px", marginRight: "5px", margintop: "1px" }}
        />
      ),
    },
  ];

  const handleSubCategoryChange = (value) => {
    setCategory(value);
    formRef.current?.setFieldsValue({ application: "" });
  };

  const filteredApplications = applications.filter((app) => app.id === -1);
  return (
    <Sidebar props={SettingsMenu}>
      {contextHolder}
      <SecondaryNav menuItems={SecondaryNavTNCommunications} />
      <ThirdBar menuItems={thirdMenuData} />
      <Spin spinning={loading}>
        <Row style={{ height: `${remainingViewportHeight(15)}px` }}>
          <Col
            span={11}
            style={{ padding: "20px", borderRight: "1px solid #ddd" }}
          >
            {/* <div className="form-container-2"> */}
            <Form
              name="complex-form"
              onFinish={onFinish}
              layout="vertical"
              ref={formRef}
              labelCol={{ span: 25 }}
              wrapperCol={{ span: 80 }}
              style={{ width: "100%", marginBottom: "150px" }}
              onValuesChange={(_, allValues) => {
                setFormDataPass(allValues);
              }}
            >
              <div className="group1">
                <div className="form-heading" style={{ paddingTop: "1rem" }}>
                  {capitalizeWords("Custom notification details")}
                </div>
                <div className="antd-test-client" style={{ marginTop: "4rem" }}>
                  <Row gutter={20} style={{ marginLeft: "2rem" }}>
                    <Col xs={24} sm={14} md={14} lg={14} xl={14}>
                      <Form.Item
                        label={
                          <>
                            <p
                              className="my-form-lables"
                              style={{ width: "100%" }}
                            >
                              Category
                            </p>
                          </>
                        }
                      >
                        <Form.Item
                          noStyle
                          rules={[
                            { required: true, message: "category is required" },
                          ]}
                          name="sub_category"
                        >
                          <Select
                            className="my-form-input-antd-test"
                            placeholder="Select any one"
                            onChange={handleSubCategoryChange}
                          >
                            <Option value="Maintenance">Maintenance</Option>
                            <Option value="Product Announcement">
                              Product Announcement
                            </Option>
                          </Select>
                        </Form.Item>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={10} lg={8} xl={8}>
                      <Form.Item
                        label={<p className="my-form-lables">Priority</p>}
                      >
                        <Form.Item
                          noStyle
                          name="priority"
                          rules={[
                            {
                              required: true,
                              message: "priority time is required",
                            },
                          ]}
                        >
                          <Select
                            className="my-form-input-antd-test"
                            placeholder="Select an option"
                          >
                            <Option value="High">High Priority</Option>
                            <Option value="Low">Low Priority</Option>
                          </Select>
                        </Form.Item>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={20} md={20} lg={18} xl={18}>
                      <Form.Item
                        label={
                          <p className="my-form-lables">Notification Title</p>
                        }
                      >
                        <Form.Item
                          noStyle
                          name="title"
                          rules={[
                            {
                              required: true,
                              message: "Title is required",
                            },
                          ]}
                          initialValue={formData?.notification_content}
                        >
                          <Input
                            className="my-form-input-antd-test"
                            placeholder="please enter the title for the notification"
                          />
                        </Form.Item>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                      <Form.Item
                        label={<p className="my-form-lables">Status</p>}
                      >
                        <Form.Item
                          noStyle
                          name="status"
                          valuePropName="checked"
                          initialValue={true}
                        >
                          <Switch
                            checkedChildren="ACTIVE"
                            unCheckedChildren="INACTIVE"
                            defaultChecked
                            name="status"
                          />
                        </Form.Item>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                      <Form.Item
                        label={<p className="my-form-lables">Application</p>}
                      >
                        <Form.Item
                          noStyle
                          name="application"
                          rules={[
                            {
                              required: true,
                              message: "application is required",
                            },
                          ]}
                        >
                          <Select
                            className="my-form-input-antd-test"
                            placeholder="Select an option"
                          >
                            {category === "Maintenance"
                              ? filteredApplications?.map((naics) => (
                                  <Option key={naics.id} value={naics.id}>
                                    {`${naics.name}`}
                                  </Option>
                                ))
                              : applications?.map((naics) => (
                                  <Option key={naics.id} value={naics.id}>
                                    {`${naics.name}`}
                                  </Option>
                                ))}
                          </Select>
                        </Form.Item>
                      </Form.Item>
                    </Col>
                    <Col xs={21} sm={21} md={14} lg={14} xl={14}>
                      <Form.Item
                        label={
                          <p className="my-form-lables">
                            Start Date & end Date
                          </p>
                        }
                      >
                        <Form.Item name="dateRange" noStyle>
                          <RangePicker
                            placeholder={["Start Date", "End Date"]}
                            name="dateRange"
                            showTime={{ format: "hh:mm A", use12Hours: true }}
                            format="YYYY-MM-DD hh:mm A"
                            className="my-form-input-antd-test"
                            allowClear={false}
                            disabledDate={(current) => {
                              return (
                                current && current < moment().startOf("day")
                              );
                            }}
                            disabledTime={(date, type) => {
                              if (type === "start") {
                                const isToday =
                                  date && date.isSame(moment(), "day");
                                if (isToday) {
                                  return {
                                    disabledHours: () => [
                                      ...Array(moment().hour()).keys(),
                                    ],
                                    disabledMinutes: (hour) =>
                                      hour === moment().hour()
                                        ? [...Array(moment().minute()).keys()]
                                        : [],
                                  };
                                }
                              }
                              return {};
                            }}
                          />
                        </Form.Item>
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={20}
                      md={20}
                      lg={22}
                      xl={22}
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                      }}
                    >
                      <p
                        className="my-form-lables"
                        style={{ marginRight: "10px" }}
                      >
                        Content Type
                      </p>

                      <Checkbox
                        checked={useStructuredPoints}
                        onChange={(e) =>
                          setUseStructuredPoints(e.target.checked)
                        }
                      >
                        Bullet Points
                      </Checkbox>
                    </Col>
                    {useStructuredPoints ? (
                      <Col xs={24} sm={20} md={20} lg={22} xl={22}>
                        <Form.Item
                          label={
                            <p className="my-form-lables">Custom Points</p>
                          }
                        >
                          <Form.List
                            name="customPoints"
                            initialValue={[{ point: "" }]}
                          >
                            {(fields, { add, remove }) => (
                              <>
                                {fields.map(
                                  (
                                    { key, name, fieldKey, ...restField },
                                    index
                                  ) => (
                                    <div
                                      key={key}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                        marginBottom: "10px",
                                        width: "100%",
                                      }}
                                    >
                                      {/* Input Field for Point */}
                                      <Form.Item
                                        {...restField}
                                        name={[name, "point"]}
                                        rules={[
                                          {
                                            required: true,
                                            message: "Point is required",
                                          },
                                        ]}
                                        style={{ flex: 2, marginBottom: 0 }}
                                      >
                                        <Input.TextArea
                                          placeholder="Enter your custom content here"
                                          autoSize={{
                                            minRows: 1,
                                            maxRows: 5,
                                          }}
                                        />
                                      </Form.Item>

                                      <Badge
                                        dot={
                                          links[name]?.name && links[name]?.url
                                            ? true
                                            : false
                                        }
                                      >
                                        <Popconfirm
                                          title={
                                            <div>
                                              <p>Enter Link Name and URL:</p>
                                              <Input
                                                defaultValue={
                                                  links[name]?.name || ""
                                                }
                                                onChange={(e) =>
                                                  setLinks({
                                                    ...links,
                                                    [name]: {
                                                      ...links[name],
                                                      name: e.target.value,
                                                    },
                                                  })
                                                }
                                                placeholder="Link Name"
                                              />
                                              <Input
                                                defaultValue={
                                                  links[name]?.url || ""
                                                }
                                                onChange={(e) =>
                                                  setLinks({
                                                    ...links,
                                                    [name]: {
                                                      ...links[name],
                                                      url: e.target.value,
                                                    },
                                                  })
                                                }
                                                placeholder="Link URL"
                                              />
                                            </div>
                                          }
                                          onConfirm={() =>
                                            console.log(
                                              "Saved Link:",
                                              links[name]
                                            )
                                          }
                                          okText="Save"
                                          cancelText="Cancel"
                                          icon={<LinkOutlined />}
                                        >
                                          <LinkOutlined
                                            style={{
                                              fontSize: "18px",
                                              cursor: "pointer",
                                              color: "#1890ff",
                                            }}
                                          />
                                        </Popconfirm>
                                      </Badge>
                                      {/* Delete Icon (Only Shows When More Than One Point Exists) */}
                                      {fields.length > 1 && (
                                        <DeleteOutlined
                                          style={{
                                            color: "red",
                                            cursor: "pointer",
                                            fontSize: "18px",
                                          }}
                                          onClick={() => remove(name)}
                                        />
                                      )}

                                      {/* Add Icon (Only Appears for the Last Row) */}
                                      {index === fields.length - 1 && (
                                        <PlusCircleOutlined
                                          onClick={() => add()}
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "18px",
                                            marginLeft: "auto",
                                          }}
                                        />
                                      )}
                                    </div>
                                  )
                                )}
                              </>
                            )}
                          </Form.List>
                        </Form.Item>
                      </Col>
                    ) : (
                      <Col xs={24} sm={20} md={20} lg={22} xl={22}>
                        <Form.Item
                          label={
                            <p className="my-form-lables">
                              Text Content - Editor
                            </p>
                          }
                        >
                          <ReactQuill
                            theme="snow"
                            value={content}
                            modules={quillModules}
                            onChange={setContent}
                            placeholder="Enter your custom content here"
                          />
                        </Form.Item>
                      </Col>
                    )}
                  </Row>
                </div>
              </div>
              <div style={{ display: "inline-block", marginLeft: "5rem" }}>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="text"
                    htmlType="button"
                    style={{
                      background: "#D3D3D3",
                    }}
                  >
                    <BackwardOutlined />
                    Back
                  </Button>
                </Form.Item>
              </div>

              <div style={{ display: "inline-block", marginLeft: "16px" }}>
                <Form.Item label=" " colon={false}>
                  <Button type="primary" htmlType="button">
                    Reset
                  </Button>
                </Form.Item>
              </div>
              <div style={{ display: "inline-block", marginLeft: "16px" }}>
                <Form.Item label=" " colon={false}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    // className="my-form-input-end"
                    style={{
                      background: "#f58029",
                      // fontWeight: "600",
                    }}
                    className="save-update-btn"
                  >
                    Update
                    <FormOutlined />
                  </Button>
                </Form.Item>
              </div>
            </Form>
            {/* </div> */}
          </Col>

          <Col
            span={13}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              background: "#f4f4f4",
            }}
          >
            <MaintainenceModal
              isDowntimeModalVisible={isModalVisible}
              closeDowntimeModal={closeDowntimeModal}
              applications={applications}
              formData={formDataPass}
              links={links}
              content={content}
              useStructuredPoints={useStructuredPoints}
            />
          </Col>
        </Row>
      </Spin>
    </Sidebar>
  );
};

export default CustomNotificationsEdit;
